<div class="flex flex-wrap rounded-lg w-full">
  <!-- ? Actions -->
  <div class="w-full md:mb-2 py-2 md:py-0 flex flex-wrap items-center rounded-md lg:bg-gray-50 dark:bg-gray-800"
    [ngClass]="{'fade': displayActions}">
    <ng-container *ngIf="displayActions">
      <ng-container *ngTemplateOutlet="Buttons"></ng-container>
    </ng-container>
  </div>

  <!-- ? Action Buttons -->
  <div class="hidden lg:flex w-4/12 sm:w-full justify-center sm:justify-start" *ngIf="displayAdd">
    <button class="w-14 h-14 !rounded-full btn-green-flat flex items-center justify-center"
      [ngClass]="{ 'rotate-[225deg] !transition !duration-[1s]': displayActions }"
      (click)="displayActions = !displayActions">
      <span class="icon add-regular text-xl text-white"></span>
    </button>
  </div>
</div>

<ng-template #Buttons>
  <!-- ? Create Review -->
  <div
    class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700 rounded-md"
    (click)="closeDialog(routes.review_create)">
    <button tabindex="-1" class="icon-btn flex items-center justify-center cursor-pointer">
      <span
        class="icon text-green-500 dark:bg-gray-700 notepad-edit-regular min-w-8 min-h-8 rounded-full flex items-center justify-center text-xs shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="w-full text-green-500 text-center md:text-start md:mr-2 text-xs">
      یادداشت
    </span>
  </div>

  <!-- ? Create List -->
  <div
    class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700"
    (click)="closeDialog(routes.create_booklist)">
    <button tabindex="-1" class="icon-btn flex items-center justify-center cursor-pointer ">
      <span
        class="icon text-green-500 dark:bg-gray-700 apps-list-regular [transform:rotateY(180deg)] min-w-8 min-h-8 rounded-full flex items-center justify-center text-xs shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="w-full text-green-500 text-center md:text-start md:mr-2 text-xs">
      لیست
    </span>
  </div>

  <!-- ? Create Book -->
  <!-- <div class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700" (click)="closeDialog(routes.create_book)">
    <button tabindex="-1" class="icon-btn flex items-center justify-center cursor-pointer">
      <span
        class="icon text-green-500 dark:bg-gray-700 book-add-regular min-w-8 min-h-8 rounded-full flex items-center justify-center text-sm shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="w-full text-green-500 text-start md:mr-2">
      کتاب
    </span>
  </div> -->

  <!-- ? Create Reading Progress -->
  <div
    class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700"
    *ngIf="currentUser" (click)="closeDialog(routes.challenges_progress)">
    <button tabindex="-1" class="icon-btn btn-progress flex items-center justify-center cursor-pointer">
      <span
        class="icon dark:bg-gray-700 text-green-500 book-open-regular min-w-8 min-h-8 rounded-full flex items-center justify-center text-xs shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="mt-1 w-full text-center md:text-start md:mr-2 text-xs text-green-500"> گزارش مطالعه </span>
  </div>



  <!-- ? Create Post -->
  <div
    class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700"
    *ngIf="currentUser && currentUser?.isBlogger" (click)="closeDialog(routes.post_create)">
    <button tabindex="-1" class="icon-btn flex items-center justify-center cursor-pointer">
      <span
        class="icon text-green-500 dark:bg-gray-700 compose-regular min-w-8 min-h-8 rounded-full flex items-center justify-center text-xs shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="w-full text-green-500 text-center md:text-start text-xs md:mr-2">
      پست
    </span>
  </div>

  <!-- ? Create Quote -->
  <div
    class="w-1/3 md:w-full flex max-md:flex-wrap justify-center md:justify-start items-center py-1 md:pr-2 cursor-pointer lg:hover:bg-gray-100 lg:hover:dark:bg-gray-700 rounded-md"
    (click)="closeDialog(routes.quote_create)">
    <button tabindex="-1" class="icon-btn text-green-500 flex items-center justify-center cursor-pointer">
      <span
        class="icon dark:bg-gray-700 text-green-500 text-quote-regular min-w-8 min-h-8 rounded-full flex items-center justify-center text-sm shadow-xl dark:shadow-gray-900"></span>
    </button>
    <span class="w-full text-green-500 text-center md:text-start text-xs md:mr-2">
      بریدۀ کتاب‌
    </span>
  </div>
</ng-template>